import React from "react";
import WebSocketSession from "../../WebSocket/WebSocketSession";
import JoinMeetingPopUp from "./JoinMeetingPopUp/JoinMeetingPopUp";
import { useAuthenticatedUser } from "../../Providers/AuthenticatedUserProvider/AuthenticatedUserProvider";

interface Props {
  children: React.ReactNode;
}

const PopUp = (props: Props) => {
  const { children } = props;
  const [authenticatedUser] = useAuthenticatedUser();

  if (
    authenticatedUser.isLoggedIn &&
    authenticatedUser.token &&
    authenticatedUser.user?.id
  ) {
    return (
      <WebSocketSession>
        <JoinMeetingPopUp>{children}</JoinMeetingPopUp>
      </WebSocketSession>
    );
  }

  return <>{children}</>;
};

export default PopUp;
